import Pricing6_2 from './Pricing6_2'
export default Pricing6_2
